import { combineReducers } from 'redux';

import duwForm from './discharge-upgrade-wizard';

export default {
  dischargeUpgradeWizard: combineReducers({ duwForm }),
};
